import { memo } from "react";

import { getTzDayjs } from "@m7-health/shared-utils";

import { IUser } from "@/api";
import { useCurrentTimezone } from "@/common/hooks";

import { IEventLogComponent } from "../events";

export const StaffAndDay = memo(
  ({
    staffId,
    date,
    usersById,
  }: {
    staffId?: IUser["id"];
    date?: string;
    usersById: IEventLogComponent["usersById"];
  }) => {
    const timezone = useCurrentTimezone();
    const staff = (staffId && usersById?.[staffId]) || { firstName: "", lastName: "" };

    return (
      <>
        <span style={{ whiteSpace: "nowrap" }} data-testid="full-name">
          {staff?.firstName} {staff?.lastName}
        </span>{" "}
        on{" "}
        <span style={{ whiteSpace: "nowrap" }} data-testid="date">
          {getTzDayjs(date, timezone).format("MM-DD-YYYY")}
        </span>
      </>
    );
  },
);
